import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ReportTypes } from '@shared/constants/constants';

@Pipe({
    name: 'reportType'
})
export class ReportTypePipe implements PipeTransform {
    constructor(
        private translation: TranslateService
    ) { }
    transform(value: number): string {
        let result = '';
        const itemsStatusAttendee = ReportTypes(this.translation);
        if (itemsStatusAttendee){
            const selected = itemsStatusAttendee.find(x => x.id === value);
            if (selected){
                result = selected.text;
            }
        }

        return result;
    }
}
